export function svgStringToDataUri(svgString: string): string {
    return `data:image/svg+xml;base64,${window.btoa(svgString)}`;
}
